export default "__VITE_ASSET__lQUWUHlr__"